"use client";

import React from "react";
import { Play, Clock, CircleCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function RoupasImpecaveisTempoParaVoce() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222311" id="effortless-living-starts-here" className="relative overflow-hidden bg-background py-20 lg:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-30">
        <div className="bg-accent/40 absolute left-[-10%] top-[-10%] h-[500px] w-[500px] rounded-full blur-[100px]" />
        <div className="bg-secondary/30 absolute bottom-[-10%] right-[-10%] h-[600px] w-[600px] rounded-full blur-[120px]" />
      </div>

      <div className="container relative mx-auto px-4 md:px-6">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-8">
          
          {}
          <div ref={textRef} className={`flex flex-col justify-center space-y-8 transition-all duration-1000 ease-out ${isTextVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            <div className="space-y-6">
              <h1 className="font-default text-5xl font-bold leading-[1.1] tracking-tighter text-foreground sm:text-6xl xl:text-7xl">
                Effortless{" "}
                <span className="bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647152/img/minimalist_texture_mask.png)] bg-cover bg-center bg-clip-text text-transparent">
                  Living
                </span>
                ,<br /> Starts Here
              </h1>
              <p className="max-w-[600px] text-lg font-light leading-relaxed text-muted-foreground md:text-xl">
                Moza Casa brings the art of simple living to your doorstep. 
                Master your Apple HomeKit environment with curated tips and 
                automation recipes designed for a serene, modern home.
              </p>
            </div>

            <div className="flex flex-col gap-4 sm:flex-row">
              <Button asChild size="lg" className="h-14 rounded-full px-8 text-base shadow-lg bg-primary text-primary-foreground hover:shadow-xl transition-shadow">
                <Link to="/MozaMethodPage">Explore the Method</Link>
              </Button>
              <Button asChild variant="ghost" size="lg" className="h-14 rounded-full px-8 text-base hover:bg-accent/50 border border-primary/10">
                <Link to="AutomationRecipesPage">
                  <Play className="mr-2 size-5 fill-current" />
                  Live Scenes
                </Link>
              </Button>
            </div>

            <div className="flex items-center gap-6 pt-4 text-sm font-medium text-muted-foreground">
              <div className="flex items-center gap-2">
                <CircleCheck className="size-5 text-primary" />
                <span className="tracking-wider uppercase text-[12px]">Apple HomeKit Native</span>
              </div>
              <div className="flex items-center gap-2">
                <CircleCheck className="size-5 text-primary" />
                <span className="tracking-wider uppercase text-[12px]">Minimalist Design</span>
              </div>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`relative mx-auto w-full max-w-[500px] lg:max-w-none transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
            <div className="relative aspect-[4/5] overflow-hidden rounded-[2.5rem] shadow-2xl">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647152/img/sunlit_minimalist_living_room.png" alt="Sunlit minimalist living room with smart lighting" className="h-full w-full object-cover transition-transform duration-1000 hover:scale-105" />
              
              {}
              <div className="absolute inset-0 rounded-[2.5rem] ring-1 ring-inset ring-black/5" />
            </div>

            {}
            <div className="absolute -left-6 top-1/4 flex animate-[bounce_4s_infinite] items-center gap-4 rounded-full border border-white/40 bg-white/70 p-3 pr-6 shadow-md backdrop-blur-md sm:-left-12">
              <div className="flex size-12 items-center justify-center rounded-full bg-primary text-primary-foreground">
                <Clock className="size-6" />
              </div>
              <div className="flex flex-col">
                <span className="font-default text-base font-bold text-foreground">
                  Good Morning
                </span>
                <span className="text-xs font-medium text-muted-foreground">
                  Scene Active
                </span>
              </div>
            </div>
            
            {}
            <div className="absolute -right-8 bottom-12 -z-10 h-32 w-32 bg-[radial-gradient(circle,var(--color-border)_2px,transparent_2px)] [background-size:16px_16px] opacity-30" />
          </div>
          
        </div>
      </div>
    </section>;
}